

import { Magic } from "magic-sdk";

let _magic = null;

export function getMagic() {
  if (!_magic) {
    _magic = new Magic(process.env.REACT_APP_MAGIC_PUBLISHABLE_KEY, {
      network: {
        rpcUrl: "https://polygon-rpc.com",
        chainId: 137, // Polygon mainnet
      },
    });
  }
  return _magic;
}